// import VueEmail from './VueEmail'
// import VueEmailModal from './VueEmailModal'
const VueEmail = r => require.ensure([], () => r(require('./VueEmail.vue')), 'email-components-chunk')
const VueEmailModal = r => require.ensure([], () => r(require('./VueEmailModal.vue')), 'email-components-chunk')

export { VueEmail, VueEmailModal }
